// extracted by mini-css-extract-plugin
export var copyright = "copyright-module--copyright--gS-m0";